import React, { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatErr } from "../lib/api";

export default function AdminLogin() {
  const { login, user, checked } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  if (!checked) return <div className="min-h-screen flex items-center justify-center"><div className="bn-eyebrow">...</div></div>;
  if (user && user !== false) return <Navigate to="/val-benova-admin-2026" />;

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      await login(email, password);
      nav("/val-benova-admin-2026");
    } catch (e) {
      setErr(formatErr(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-8" style={{ background: "var(--bn-bg)" }} data-testid="admin-login">
      <Link to="/" className="bn-eyebrow inline-flex items-center gap-2 mb-6 self-start max-w-md w-full" style={{ color: "var(--bn-text-muted)" }} data-testid="admin-login-back">
        <ArrowLeft size={14} /> Volver al sitio
      </Link>
      <div className="w-full max-w-md bn-card p-8 md:p-10">
        <div className="bn-eyebrow" style={{ color: "var(--bn-accent)" }}>Benova Admin</div>
        <h1 className="bn-heading text-3xl md:text-4xl mt-3">Acceso privado</h1>
        <p className="mt-2 text-sm" style={{ color: "var(--bn-text-muted)" }}>Solo usuarios autorizados.</p>

        <form onSubmit={submit} className="mt-8 space-y-4">
          <div>
            <label className="bn-eyebrow block mb-2">Email</label>
            <input type="email" required className="bn-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-login-email" />
          </div>
          <div>
            <label className="bn-eyebrow block mb-2">Contraseña</label>
            <input type="password" required className="bn-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-login-password" />
          </div>
          {err && <div className="text-sm p-3" style={{ background: "rgba(220,38,38,0.1)", color: "#b91c1c", borderRadius: "var(--bn-button-radius)" }}>{err}</div>}
          <button type="submit" disabled={loading} className="bn-btn-primary w-full justify-center" data-testid="admin-login-submit">
            {loading ? "Accediendo..." : "Entrar"}
          </button>
        </form>
      </div>
      <Link to="/" className="mt-6 bn-eyebrow text-xs underline" style={{ color: "var(--bn-text-muted)" }}>
        ← benova.club
      </Link>
    </div>
  );
}
